module.exports = __webpack_public_path__ + "static/img/PT.be603b88.png";